export default "__VITE_ASSET__f74ea09f__"